module.exports = __webpack_public_path__ + "2f04cd3c63f8b181f5fbcec3b663eb12.svg";